import React from "react";
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import { Tags } from "@aph/ui-lib-humanx";
import { hideNavigationItem } from "@/helpers/hideNavigationItem";
import { clientRoutes } from "@/helpers/clientRoutes";
import { NEXT_PUBLIC_APOLLO_247_URL, NEXT_PUBLIC_APOLLO_247_INSURANCE_URL } from "@/libs/constants/auth";
import latitudeSelector from "@/redux/slice/location/selectors/latitude";
import longitudeSelector from "@/redux/slice/location/selectors/longitude";
import { useAppSelector } from "@/redux/hooks";
import styles from "./RawMenue.module.scss";

const RawMenu = () => {
  const lat = useAppSelector(latitudeSelector);
  const long = useAppSelector(longitudeSelector);
  const searchParams = useSearchParams();
  const routerPathname = usePathname();

  const rawMenusList = [
    {
      name: "Buy Medicines",
      url: `https://www.apollopharmacy.in${clientRoutes.welcome()}`,
      ariaLabel: "logo",
      tagRequired: false,
      hideOnParams: { hideMedicines: "true" },
    },
    {
      name: "Find Doctors",
      url: `${NEXT_PUBLIC_APOLLO_247_URL}${clientRoutes.specialityListing()}`,
      ariaLabel: "FindDoctors",
      tagRequired: false,
      hideOnParams: { hideDoctors: "true" },
    },
    {
      name: "Lab Tests",
      url: `${NEXT_PUBLIC_APOLLO_247_URL}${clientRoutes.tests()}${lat && long ? `?lat=${lat}&long=${long}` : ""}`,
      ariaLabel: "LabTests",
      tagRequired: false,
      hideOnParams: { hideLabTests: "true" },
    },
    {
      name: "Circle Membership",
      url: clientRoutes.careLanding(),
      ariaLabel: "CircleMembership",
      tagRequired: false,
      hideOnParams: { hideCircle: "true" },
    },
    {
      name: "Health Records",
      url: `${NEXT_PUBLIC_APOLLO_247_URL}${clientRoutes.healthRecords("prescription")}`,
      ariaLabel: "Health Records",
      tagRequired: false,
      hideOnParams: { hideHealthRecords: "true" },
    },
    {
      name: "Credit Card",
      url: `${NEXT_PUBLIC_APOLLO_247_URL}${clientRoutes.sbiCreditCard()}?utm_source=apollopharmacy&utm_medium=navbar`,
      ariaLabel: "Credit Card",
      tagRequired: true,
      tagLabel: "New",
      hideOnParams: { hideCreditCard: "true" },
    },
    {
      name: "Buy Insurance",
      url: `${NEXT_PUBLIC_APOLLO_247_INSURANCE_URL}`,
      ariaLabel: "Buy Insurance",
      tagRequired: true,
      tagLabel: "New",
      hideOnParams: { hideInsurance: "true" },
    },
  ];

  const MenusList = rawMenusList?.filter((item) => !hideNavigationItem(item?.hideOnParams, searchParams));

  return (
    <ul className={styles.navRoot}>
      {MenusList?.map((menuItem) => {
        return (
          <li
            className={`${styles.list} ${menuItem?.url === routerPathname ? styles.active : ""}`}
            key={`topNavBar_${menuItem?.name}`}
          >
            <Link href={menuItem?.url} prefetch={false} aria-label={menuItem?.ariaLabel}>
              {menuItem?.name}
              {menuItem?.tagRequired && menuItem?.tagLabel && (
                <Tags status="completed" label={menuItem?.tagLabel} variant="filled" size="xs" fontWeight={600} />
              )}
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default RawMenu;
